import React from 'react';
import {Accept, FileWithPath, useDropzone} from 'react-dropzone';
import {FaFileUpload} from "react-icons/fa";

interface  PropsI {
    onDrop: (a: File[])=>void;
    accept: Accept;
    open: ()=>void;
}

function Dropzone({ onDrop, accept, open }: PropsI) {
    const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
        useDropzone({
            accept,
            onDrop,
        });

    const files = acceptedFiles.map((file:FileWithPath) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    return (
        <div>
            <div {...getRootProps({ className: "dropzone" })}>
                <input className="input-zone" {...getInputProps()} />
                <div>
                    {isDragActive ? (
                        <div className="form__file-uploader active">
                            <div className="mr-4">
                                <FaFileUpload className="text-4xl text-grayscaleLabel" />
                            </div>
                            <div className="w-full">
                                <div>Release to drop the files here</div>
                                <div>(PDF/JPG/PNG)</div>
                            </div>
                        </div>
                    ) : (
                        <div className="form__file-uploader">
                            <div className="mr-4">
                                <FaFileUpload className="text-4xl text-grayscaleLabel" />
                            </div>
                            <div>
                                <div>Drag and drop here or <button className="btn btn-text text-primary inline" onClick={open}>click</button> to upload.</div>
                                <div>(PDF/JPG/PNG)</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
}

export default Dropzone;